export class ContractSpacePeriodPackagePriceOffice {
  id: number | undefined
  active: boolean
  desks: number
  free: boolean
  discount: number
  discountAmount: number
  totalPrice: object | null
  deskPrice: object | null
  dateCreated: Date | string
  spacePeriodPackagePrice: object | null

  constructor() {
    this.active = false
    this.desks = 0
    this.free = false
    this.discount = 0
    this.discountAmount = 0
    this.totalPrice = null
    this.deskPrice = null
    this.dateCreated = ''
    this.spacePeriodPackagePrice = null
  }
}
